export * from './krankheit.interface';
export * from './rahmen-anpassung.interface';
export * from './tag.interface';
export * from './urlaub.interface';
export * from './zeit';
export * from './zeit-art';
export * from './zeit-unterart';
